import Banner from "./banner";
import Course from "./course";
import About from "./about";
import Footer from "../layout/footer";
import Enquiry from "../pages/enquiry"
import Add from "../images/add.png";
import Edit from "../images/edit.png";
import Delete from "../images/delete.png";
import lock from "../images/lock.png";
import { Component } from "react";
import $ from "jquery";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { saveItCareerForm } from "../service";
import { editorState, convertToRaw, ContentState, convertFromHTML, Modifier, EditorState } from 'draft-js';
import draftToHtml from "draftjs-to-html";
import Parser from "html-react-parser";
import { cityNameGlobal } from "../components/GlobalCity.js";


const editorTools = {
  options: ["inline", "link", "list"],
  inline: {
    options: ["bold", "italic", "underline", "superscript", "subscript"],
  },
  link: {
    options: ["link"],
  },
  list: {
    options: ["unordered", "ordered"],
  },
};
// var cityName = window.location.host.split('.')[0]
// var cityName ="bangalore"
const city = window?.location?.pathname?.split?.('/')?.pop?.();
const cityName = cityNameGlobal ? cityNameGlobal : city
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditorAboutActive: "0",
      bannerArray: [],
      aboutArray: [],
      aboutContentDataSubId: "",
      ["editorState1"]: "",
      aboutArrayList: [],
      descriptionstate: "",
      serviceArray: [],
      benifitsArray: [],
      enquiryArray: [],
      NoteSecArray: [],
      PowerdByArray: [],
      isDataFetch: '0'
    }
    this.getData = this.getData.bind(this);
  }


  componentDidMount() {
    this.getData();
    // this.getAwsDetails();
  }
  getData() {
    let userRole = "";
    if (localStorage.getItem("role")) {
      userRole = localStorage.getItem("role");
    }
    let postData = {
      functionName: "contentData",
      siteId: "",
      editMode: "",
      editId: "",
      displayName: "",
      userRole: userRole,
      userRole: "",
      pageId: "1",
      subDomainName: cityName
    };
    saveItCareerForm(postData).then((data) => {
      console.log("dataAbout = ", data);
      if (data.data.success === "1") {
        let bannerArray = data.data.result.contentList.filter(
          (sectionObject) => sectionObject.contentSectionName === "Banner"
        );
        let aboutArray = data.data.result.contentList.filter(
          (sectionObject) => sectionObject.contentSectionName === "About"
        );
        let serviceArray = data.data.result.contentList.filter(
          (sectionObject) => sectionObject.contentSectionName === "Services"

        );
        let benifitsArray = data.data.result.contentList.filter(
          (sectionObject) => sectionObject.contentSectionName === "Benifits"

        );
        let enquiryArray = data.data.result.contentList.filter(
          (sectionObject) => sectionObject.contentSectionName === "Enquiry"
        );
        let NoteSecArray = data.data.result.contentList.filter(
          (sectionObject) => sectionObject.contentSectionName === "Note"
        );
        let PowerdByArray = data.data.result.contentList.filter(
          (sectionObject) => sectionObject.contentSectionName === "CopyWrite"
        );
        this.setState({
          bannerArray:bannerArray,
          aboutContentId: aboutArray[0].contentDataId,
          aboutArray: aboutArray,
          aboutArrayList: aboutArray[0].listing,
          serviceArray: serviceArray,
          benifitsArray: benifitsArray,
          enquiryArray: enquiryArray,
          NoteSecArray: NoteSecArray,
          PowerdByArray: PowerdByArray,
          isDataFetch: '1'

        });
        if (aboutArray[0].listing.length > 0) {
          this.setState({
            descriptionstate: aboutArray[0].listing[0].contentDataSubSubtitle,
          })
        }

      }
    });
  }
  onEditorStateChange = (e, mode) => {
    this.setState({
      [mode]: e,
    });
  };
  handleBeforeInput = (e, mode) => {
    const currentContent = this.state[mode].getCurrentContent();
    const currentContentLength = currentContent.getPlainText("").length;
    if (currentContentLength >= 1000) {
      return "handled";
    }
  };
  save() {
    var flag = true
    if (this.state["editorState1"] === '') {
      alert("Enter Description")
      return false;
    }
    if (flag == true) {
      let contentDataId = this.state.aboutContentId
      let description = draftToHtml(
        convertToRaw(this.state["editorState1"].getCurrentContent())
      );

      this.saveAbout(
        contentDataId,
        description,
      );
    }
  }
  saveAbout(
    contentDataId, description
  ) {
    const postData = {
      functionName: "saveContentDataSub",
      contentDataId: contentDataId,
      contentDataSubId: this.state.aboutArrayList.length > 0 ? this.state.aboutArray[0].listing[0].contentDataSubId : "",
      contentDataSubDescription: "",
      contentDataSubTitle: "",
      siteId: "",
      contentDataSubIsApproved: "0",
      image: "",
      userRole: "SuperAdmin",
      oldImage: "",
      isSaveDraft: "0",
      contentDataSubSortOrder: "",
      pageId: "1",
      altText: "",
      h3Tag: "",
      contentDataSubSubtitle: description,
    };
    console.log("postDataaaa", postData);
    saveItCareerForm(postData).then((data) => {
      console.log("hhhhhh.....", data);
      if (data.data.success == 1) {
        this.getData()
        this.cancelCourseWrapper();
      }
    });
  }

  editAboutSec() {
    $(".courseWrapper").addClass("editActive");
    this.setState({ isEditorAboutActive: "1" });
    if (this.state.aboutArrayList.length > 0) {
      this.setState({
        ["editorState1"]: EditorState.createWithContent(
          ContentState.createFromBlockArray(
            convertFromHTML(this.state.aboutArrayList[0].contentDataSubSubtitle)
          )
        ),
      });
    }
  }

  deleteaboutsec(mode) {
    if (mode === "delete") {
      const postData = {
        functionName: "delete",
        contentDataSubId: this.state.aboutArray[0].listing[0].contentDataSubId,
      };
      if (window.confirm("Do you want to delete?")) {
        saveItCareerForm(postData).then((data) => {
          if (data.data.success == 1) {
            this.getData();
            window.location.reload();
          }
        });
      } else {
        return false;
      }
    }
  }

  AddCourseWrapper() {
    $(".courseWrapper").addClass("editActive");
    this.setState({ isEditorAboutActive: "1" });
  }
  cancelCourseWrapper() {
    $(".courseWrapper").removeClass("editActive");
    this.setState({ isEditorAboutActive: "0" });
  }
  render() {
    return (
      this.state.isDataFetch === '1' ?
      
        <div className="main_wrapper">
          {this.state.bannerArray.length > 0 &&
            <Banner bannerArray={this.state.bannerArray} getData={this.getData}/>}
          <section className="padding courseWrapper">
            {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
              <div className="adminIconMain">
                {this.state.aboutArrayList.length == "0" ?
                  <span
                    className="editIcon addButton"
                    onClick={(e) => {
                      this.AddCourseWrapper();
                    }}
                  >
                    <img src={Add} />
                  </span>
                  :
                  <>
                    <span
                      class="editIcon editButton"
                      onClick={(e) => {
                        this.editAboutSec();
                      }}
                    >
                      <img src={Edit} />
                    </span>
                    <span class="editIcon DeleteIcon" onClick={() => this.deleteaboutsec("delete")}>
                      <img src={Delete} />
                    </span>
                  </>
                }


                {/* <span class="editIcon lockButton"><img src={lock} /></span> */}

              </div>
            }
            {/* {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
            <div className="adminIconLeft">
              <div className="approveButton">Approve</div>
              <div class="draftSpan"> Draft </div>
              <div className="rejectSection">
                <div class="rejectButton"> Reject </div>
                <textarea
                  className="rejectComment"
                  placeholder="Enter Reason"
                ></textarea>
              </div>
              <div className="rejectSection">
                <div class="rejectButton"> Rejected </div>
                <div className="rejectCommentText">Reason :</div>
              </div>
            </div>
          } */}
            <div className="container">
              <div className="col-sm-12 text-left">
                {/* {console.log("this.state.description", this.state.descriptionstate)} */}
                <p className="lead">{Parser(this.state.descriptionstate)}</p>
                {
                  this.state.isEditorAboutActive === "1" ?
                    <Editor
                      editorState={this.state["editorState1"]}
                      id={"editorState1"}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      className="editTextInput"
                      editorClassName="editorClassName"
                      onEditorStateChange={(e) =>
                        this.onEditorStateChange(e, "editorState1")
                      }
                      handleBeforeInput={(e) =>
                        this.handleBeforeInput(e, "editorState1")
                      }
                      handlePastedText={(input) => {
                        const inputLength = this.state["editorState1"]
                          .getCurrentContent()
                          .getPlainText().length;
                        let remainingLength = 2500 - inputLength;
                        if (input.length + inputLength > 2500) {
                          const newContent = Modifier.replaceText(
                            this.state["editorState1"].getCurrentContent(),
                            this.state["editorState1"].getSelection(),
                            input.slice(0, remainingLength)
                          );
                          this.onEditorStateChange(
                            EditorState.push(
                              this.state["editorState1"],
                              newContent,
                              "insert-characters"
                            ),
                            "editorState1"
                          );
                          return true;
                        } else {
                          return false;
                        }
                      }}
                      toolbar={{
                        editorTools,
                      }}
                    />
                    : ""
                }
                <div className="editPanelButton">
                  {/* <span className="saveButton saveDraft">Save Draft</span> */}
                  <span className="saveButton" onClick={() => { this.save() }}>Submit</span>
                  <span className="cancelButton" onClick={(e) => { this.cancelCourseWrapper() }}>Cancel</span>
                </div>
              </div>
            </div>
          </section>
          {this.state.serviceArray.length > 0 &&
            <Course serviceArray={this.state.serviceArray} getData={this.getData} />}
          {/* {console.log("benifits******=",this.state.benifitsArray)} */}
          {this.state.benifitsArray.length > 0 &&
            <About benifitsArray={this.state.benifitsArray} getData={this.getData} />}
          {this.state.enquiryArray.length > 0 &&
            <Enquiry enquiryArray={this.state.enquiryArray} getData={this.getData} />}
          {/* <section className="bgdefault overlapSection">
          <div className="container">
            <div className="col-md-12 overlapSectionInner text-center wow slideInRight">
              <span>Take the first step with us.</span>{" "}
              <a className="calltoActionBtn gotoForm" href="#">
                <i className="ion-compose"></i>Fill the enquiry form
              </a>
              <span> &amp; we will call you back</span>
            </div>
          </div>
        </section> */}
          {this.state.NoteSecArray.length > 0 &&
            <Footer NoteSecArray={this.state.NoteSecArray} getData={this.getData} PowerdByArray={this.state.PowerdByArray} />}
        </div>
        : ""
    );
  }
}
export default Home;
